import {Component, EventEmitter, Input, OnChanges, OnInit, Output,} from '@angular/core';
import {TmStatusEnum} from "../../../enum/tm-status.enum";
import {TicketActionAvailableResponseDto} from "../../../model/dto/api/ticket-action-available-response.dto";
import {TicketActionDto} from "../../../model/dto/entity/ticket-action.dto";
import {TicketActionStatusInternal} from "../../../enum/ticket-action-status-internal.enum";
import {TicketActionAvailableDto} from "../../../model/dto/api/ticket-action-available.dto";
import {TicketService} from "../../../service/api/ticket.service";
import {TicketActionService} from "../../../service/api/ticket-action.service";
import {ConfirmationService} from "primeng/api";
import {TmTicketDto} from "../../../model/dto/entity/tm-ticket.dto";
import {forkJoin} from "rxjs";
// TODO Dependency
import {AgentService} from "../../../../am/service/api/agent.service";
// TODO Dependency
import {AgentPoolService} from "../../../../am/service/api/agent-pool.service";
// TODO Dependency
import {AgentPoolDto} from "../../../../am/model/dto/entity/agent-pool.dto";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {MvsFormControlOverwrite} from "../../../../../core/shared/logic/form/logic/mvs-form-control-overwrite";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {ObjectChangeInformation} from "../../../../../core/shared/logic/object-change-information";
import {MvsFormFieldAccessEnum} from "../../../../../core/shared/logic/form/logic/mvs-form-field-access.enum";
import {ObjectRequestComplex} from "../../../../../core/shared/dto/object/request/object-request-complex";
import {ObjectRequestComplexNode} from "../../../../../core/shared/dto/object/request/object-request-complex-node";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {DtoList} from "../../../../../core/shared/dto/dto.list";


@Component({
    selector: 'ticket-complete-form',
    templateUrl: 'ticket-complete-form.component.html',
    standalone: false
})
export class TicketCompleteFormComponent implements OnInit, OnChanges {

    initialized: boolean;
    createDefaultDto: DtoDetail;
    formControlOverwrite: MvsFormControlOverwrite;
    actionsList: TicketActionDto[]
    actionAvailableDto: TicketActionAvailableDto[];

    @Input() ticketDto: TmTicketDto;
    ticketActionsList: TicketActionDto[];
    availableActionsResponse: TicketActionAvailableResponseDto;

    @Output() onAddTicketAction = new EventEmitter<string>;
    @Output() onInitiateProcess = new EventEmitter<ObjectIdentifier>;
    @Output() onChangedObject = new EventEmitter<ObjectChangeInformation>;

    constructor(protected ticketService: TicketService,
                protected ticketActionService: TicketActionService,
                protected agentService: AgentService,
                protected agentPoolService: AgentPoolService,
                private confirmationService: ConfirmationService) {
    }

    ngOnInit() {
        this.initComponent();
    }

    initComponent() {
        this.formControlOverwrite = MvsFormControlOverwrite.createHideAll('closingStatusDtoId', 'closingComment', 'status');
        this.formControlOverwrite.addField('status', MvsFormFieldAccessEnum.READ);

        const defaultDto: any = {
            status: TmStatusEnum.resolved,
            closingDate: new Date(),
        }

        this.createDefaultDto = defaultDto;

        this.getAvailableTicketActions();
        this.getTicketActionList();

        this.initialized = true;
    }

    getAvailableTicketActions() {
        this.ticketService.getAvailableActions(this.ticketDto.id).subscribe(res => {
            this.availableActionsResponse = res;
            this.actionAvailableDto = this.availableActionsResponse?.availableActions.filter(action => (
                action.exists == true &&
                action.existsStatusInternal != TicketActionStatusInternal.completed &&
                action.existsStatusInternal != TicketActionStatusInternal.cancelled &&
                action.existsStatusInternal != TicketActionStatusInternal.negative_completed)
            );
            this.availableActionsResponse.availableActions = this.actionAvailableDto;
        })
    }

    getTicketActionList() {

        const complexSelection =
            ObjectRequestComplex.build(false, false,
                ObjectRequestComplexNode.createSimpleAttributeNode('ticketTypeAction')
            );


        const filterCriteria = [
            FilterCriteria.create('ticket', FilterCriteria.cOperatorEqual, this.ticketDto.id),
            FilterCriteria.create('statusInternal', FilterCriteria.cOperatorNotEqual, TicketActionStatusInternal.completed),
            FilterCriteria.create('statusInternal', FilterCriteria.cOperatorNotEqual, TicketActionStatusInternal.cancelled),
        ]

        const objectRequestList = ObjectRequestList.createComplexRequestList(
            false,
            complexSelection,
            filterCriteria,
            null,
            null,
            null);

        this.ticketActionService.list(objectRequestList).subscribe(res => {
            const ticketActions = res.entries;

            if (ticketActions && ticketActions.length) {
                this.ticketActionsList = ticketActions.filter(item => item.mandatory == true &&
                    item.statusInternal != TicketActionStatusInternal.completed &&
                    item.statusInternal != TicketActionStatusInternal.cancelled &&
                    item.statusInternal != TicketActionStatusInternal.negative_completed);
            }

            // this.actionsList = this.ticketActionsList?.filter(action => action.statusInternal != TicketActionStatusInternal.completed);
            // this.actionAvailableDto = this.availableActionsResponse?.availableActions.filter(action => action.existsStatusInternal != TicketActionStatusInternal.completed);
            // this.availableActionsResponse.availableActions = this.actionAvailableDto;
        })
    }

    handleBeforeSaveCallback(fn: Function) {

        forkJoin({
            agent: this.agentService.me(),
            agentPools: this.agentPoolService.my()
        }).subscribe({
            next: ({ agent, agentPools }) => {
                const loggedOnAgent = agent;
                const loggedOnAgentPoolsInfo = agentPools;

                // directly close ticket without confirmation if
                // a) the agent is closing their assigned ticket
                // b) the agent is in agent pool of the assignee

                if (this.ticketDto.assigneeAgentDtoId == loggedOnAgent.id || this.checkIfLoggedOnUserInTicketPool(loggedOnAgentPoolsInfo)) {
                    fn();
                } else {

                    // otherwise show a dialog message
                    this.showConfirmationDialog(fn);
                }

            },
            error: (error) => {
                console.error('Error fetching agent or agent pools:', error);
            }
        });

    }

    checkIfLoggedOnUserInTicketPool(loggedOnAgentPools: DtoList<AgentPoolDto>): boolean {
        const exists = loggedOnAgentPools.entries.find(item => item.id == this.ticketDto.assigneeAgentPoolDtoId);
        if (exists) {
            return true;
        }
        return false;
    }

    showConfirmationDialog(fn: Function) {
        this.confirmationService.confirm({
            message: 'Are you sure you want to close this ticket?',
            header: 'Confirm Close',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            acceptButtonStyleClass: "p-button-success",
            rejectButtonStyleClass: "p-button-danger",
            accept: () => {
                fn(); // Call save function if user confirms
            },
            reject: () => {
                console.log('Save cancelled');
            }
        });
    }

    handleAddTicketAction(event: string) {
        this.onAddTicketAction.emit(event);
    }

    handleInitiateProcess(event: ObjectIdentifier) {
        this.onInitiateProcess.emit(event);
    }

    handleObjectChange(event: ObjectChangeInformation) {
        this.onChangedObject.emit(event);
    }

    handleStatusChange(action: TicketActionDto) {
        this.getTicketActionList();
        // this.ticketActionsList = this.ticketActionsList.filter(actions => actions.statusInternal != action.statusInternal);
    }

    ngOnChanges() {
        if (!this.initialized) {
            return
        }

        this.getAvailableTicketActions()
    }

}
